import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import FuturaIcon from "../components/FuturaIcon";
import { useLanguage } from "../i18n/LanguageContext";
import { LanguageSelector } from "../components/LanguageSelector";
import LegalFooter from "../components/LegalFooter";

const Privacidad = () => {
  const { t } = useLanguage();

  return (
    <div className="min-h-screen bg-[#F5F5F7] flex flex-col" data-testid="privacidad-page">
      <header className="bg-white border-b border-[#E5E5EA] sticky top-0 z-20">
        <div className="max-w-4xl mx-auto px-6 py-4 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2 text-[#6B7280] hover:text-[#111111] transition-colors">
            <ArrowLeft className="w-5 h-5" /><span className="font-medium">{t("nav_back")}</span>
          </Link>
          <div className="flex items-center gap-3">
            <LanguageSelector />
            <div className="w-8 h-8 rounded-xl bg-gradient-to-br from-[#002FA7] to-[#5B21B6] flex items-center justify-center p-1">
              <FuturaIcon className="w-full h-full text-white" />
            </div>
          </div>
        </div>
      </header>

      <main className="max-w-4xl mx-auto px-6 py-12 flex-1">
        <h1 className="font-['Outfit'] text-3xl font-semibold text-[#111111] mb-2">{t("privacy_title")}</h1>
        <p className="text-[#6B7280] text-sm mb-10">{t("privacy_updated")}</p>

        <div className="space-y-6">
          <Section title={t("privacy_s1_title")} text={t("privacy_s1_text")} />
          <Section title={t("privacy_s2_title")} text={t("privacy_s2_text")} />
          <Section title={t("privacy_s3_title")} text={t("privacy_s3_text")} />
          <Section title={t("privacy_s4_title")} text={t("privacy_s4_text")} />
          <Section title={t("privacy_s5_title")} text={t("privacy_s5_text")} />
          <Section title={t("privacy_s6_title")} text={t("privacy_s6_text")} />
          <Section title={t("privacy_s7_title")} text={t("privacy_s7_text")} />
          <Section title={t("privacy_s8_title")} text={t("privacy_s8_text")} />
          <Section title={t("privacy_s9_title")} text={t("privacy_s9_text")} />
          <Section title={t("privacy_s10_title")} text={t("privacy_s10_text")} />
        </div>
      </main>

      <LegalFooter />
    </div>
  );
};

const Section = ({ title, text }) => (
  <div className="bg-white rounded-2xl p-6 border border-[#E5E5EA]">
    <h2 className="font-['Outfit'] text-lg font-semibold text-[#111111] mb-3">{title}</h2>
    <p className="text-[#6B7280] leading-relaxed text-sm whitespace-pre-line">{text}</p>
  </div>
);

export default Privacidad;
